import React, { useState } from "react";
import Icon from "../../../components/AppIcon.jsx";
import Image from "../../../components/AppImage.jsx";
import Button from "../../../components/ui/Button.jsx";

const projectsData = {
  filters: ["All", "React", "Angular", "TypeScript", "Full Stack"],
  projects: [
  {
    id: 1,
    title: "Nike E-Commerce",
    description: "A sleek React.js-powered Nike store delivering the latest sneakers and gear with a smooth shopping experience.",
    image: "/image.png",
    imageAlt: "Modern e-commerce website interface showing product grid with fashion items, shopping cart sidebar, and clean white design on desktop monitor",
    tags: ["React", "Javascript", "Redux", "Tailwind Css", "Toast"],
    category: ["React", "TypeScript", "Full Stack"],
    liveUrl: "https://e-commerce-brown-kappa.vercel.app/",
    githubUrl: "https://github.com/rehmatcodemaster/E-Commerce",
    featured: true,
    metrics: "Responsive design · Interactive UI · Feature-rich"
  },
  {
    id: 2,
    title: "Travel And Tour Web app",
    description: "A modern React.js travel app helping users explore destinations, book trips, and plan adventures seamlessly.",
    image: "https://rehmat-online.vercel.app/assets/images/Screenshot%202025-01-27%20055319.png",
    imageAlt: "Dark-themed analytics dashboard with multiple data visualization charts, graphs showing developer metrics, and sidebar navigation on widescreen display",
    tags: ["React.js", "TypeScript", "Tailwind Css", "Redux"],
    category: ["React js", "TypeScript"],
    liveUrl: "https://travel-website-react-js-beta.vercel.app/",
    githubUrl: "https://github.com/rehmatcodemaster/Travel-Tour",
    featured: true,
    metrics: "React & Tailwind · Mobile-first design · 30% boost in session duration"
  },
  {
    id: 3,
    title: "Giphy Clone",
    description: "A React.js-powered Giphy clone that lets users search, view, and share trending GIFs seamlessly",
    image: "https://rehmat-online.vercel.app/assets/images/Screenshot%202025-01-27%20055558.png",
    imageAlt: "Calming wellness app interface with soft purple gradient background showing meditation timer, mood tracking chart, and daily streak counter on mobile device",
    tags: ["React", "Api", "Tailwind css", "Firebase"],
    category: ["React", "Full Stack"],
    liveUrl: "https://giphy-web-eta.vercel.app/",
    githubUrl: "https://github.com/rehmatcodemaster/Giphy",
    featured: false,
    metrics: "Real-time GIF Search · 100+ trending GIFs displayed · 30% faster load time"
  },
  {
    id: 4,
    title: "Sifra 2.O",
    description: "React & Gemini API · Real-time Q&A · Voice & Text Responses · 99% response accuracy",
    image: "https://rehmat-online.vercel.app/assets/images/Screenshot%202025-01-27%20060147.png",
    imageAlt: "Browser-based code editor with dark theme showing JavaScript code with syntax highlighting, split panel view, and user avatars indicating collaborative editing session",
    tags: ["React", "TypeScript", "Gemni api", "FireBase"],
    category: ["Angular", "TypeScript", "Full Stack"],
    liveUrl: "https://rehmat2006com.vercel.app/",
    githubUrl: "https://github.com/rehmatcodemaster/backend-part-4",
    featured: false,
    metrics: "Voice & Text Responses · 95% accurate answers · Seamless user experience"
  },
  {
    id: 5,
    title: "Crypto Currency Website",
    description: "A React.js-powered Cryptocurrency platform providing real-time coin prices, market trends, and portfolio tracking.",
    image: "https://rehmat-online.vercel.app/assets/images/Screenshot%202025-01-27%20061023.png",
    imageAlt: "Travel planning app showing interactive world map with pinned destinations, photo gallery grid of travel photos, and trip itinerary sidebar with timeline",
    tags: ["Angular", "Tailwind CSS", "Cli", "Hook Form"],
    category: ["Angular", "Full Stack"],
    liveUrl: "https://famous-mermaid-ad1772.netlify.app/",
    githubUrl: "https://github.com/rehmatcodemaster/Counter-App",
    featured: false,
    metrics: "Live Market Trends · 24/7 updates · 50+ market indicators displayed"
  },
  {
    id: 6,
    title: "E-Commerce-Store",
    description: "A fully-featured Angular eCommerce store delivering a seamless shopping experience with dynamic product listings, cart management, and secure checkout.",
    image: "https://rehmat-online.vercel.app/assets/images/WhatsApp%20Image%202026-02-07%20at%2012.19.38%20AM.jpeg",
    imageAlt: "Component library documentation page showing grid of UI components including buttons, cards, modals, and form elements with code snippets and live previews",
    tags: ["Angular", "TypeScript", "Json Server", "Reactive Forms"],
    category: ["Angular", "TypeScript"],
    liveUrl: "https://admirable-cucurucho-df54c8.netlify.app/",
    githubUrl: "https://github.com/rehmatcodemaster/Angular-E-commerce",
    featured: false,
    metrics: "Angular · 100+ products listed · Real-time cart & inventory updates"
  }]

};

function ProjectCard({ project }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
    id="#projects"
      className="rounded-xl border overflow-hidden transition-all duration-300 group"
      style={{
        background: "var(--color-card)",
        borderColor: hovered ? "var(--color-primary)" : "var(--color-border)",
        boxShadow: hovered ? "0 0 24px rgba(124,106,247,0.2)" : "none",
        transform: hovered ? "translateY(-4px)" : "translateY(0)"
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}>
      
      {/* Image */}
      <div className="relative overflow-hidden" style={{ height: "200px" }}>
        <Image
          src={project?.image}
          alt={project?.imageAlt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        
        {project?.featured &&
        <div
          className="absolute top-3 left-3 px-2 py-1 text-xs font-bold rounded-xs"
          style={{ background: "var(--color-primary)", color: "#fff", fontFamily: "var(--font-caption)" }}>
          
            Featured
          </div>
        }
        {/* Hover overlay */}
        <div
          className="absolute inset-0 flex items-center justify-center gap-3 transition-all duration-300"
          style={{
            background: "rgba(0,0,0,0.85)",
            opacity: hovered ? 1 : 0
          }}>
          
          <a
            href={project?.liveUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 px-4 py-2 rounded-xs text-sm font-semibold transition-all duration-200 hover:opacity-90"
            style={{ background: "var(--color-primary)", color: "#fff", fontFamily: "var(--font-heading)" }}>
            
            <Icon name="ExternalLink" size={14} color="#fff" />
            Live Demo
          </a>
          <a
            href={project?.githubUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 px-4 py-2 rounded-xs text-sm font-semibold border transition-all duration-200 hover:opacity-90"
            style={{ background: "rgba(255,255,255,0.1)", color: "#fff", borderColor: "rgba(255,255,255,0.3)", fontFamily: "var(--font-heading)" }}>
            
            <Icon name="Github" size={14} color="#fff" />
            Code
          </a>
        </div>
      </div>
      {/* Content */}
      <div className="p-5">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="text-base font-bold leading-tight" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
            {project?.title}
          </h3>
        </div>
        <p className="text-sm leading-relaxed mb-4 line-clamp-3" style={{ color: "var(--color-muted-foreground)" }}>
          {project?.description}
        </p>
        <div className="flex flex-wrap gap-1.5 mb-4">
          {project?.tags?.map((tag) =>
          <span
            key={tag}
            className="px-2 py-0.5 text-xs rounded-xs border"
            style={{ fontFamily: "var(--font-caption)", background: "var(--color-muted)", color: "var(--color-foreground)", borderColor: "var(--color-border)" }}>
            
              {tag}
            </span>
          )}
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-data)" }}>
            {project?.metrics}
          </span>
          <div className="flex gap-2">
            <a href={project?.githubUrl} target="_blank" rel="noopener noreferrer" aria-label="GitHub repository">
              <Icon name="Github" size={16} color="var(--color-muted-foreground)" />
            </a>
            <a href={project?.liveUrl} target="_blank" rel="noopener noreferrer" aria-label="Live demo">
              <Icon name="ExternalLink" size={16} color="var(--color-muted-foreground)" />
            </a>
          </div>
        </div>
      </div>
    </div>);

}

export default function ProjectsSection() {
  const [activeFilter, setActiveFilter] = useState("All");

  const filtered = activeFilter === "All" ?
  projectsData?.projects :
  projectsData?.projects?.filter((p) => p?.category?.includes(activeFilter));

  return (
    <div className="py-16 md:py-20" style={{ background: "var(--color-card)" }}>
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-widest uppercase mb-2" style={{ color: "var(--color-primary)", fontFamily: "var(--font-caption)" }}>
            My Work
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
            Featured Projects
          </h2>
          <p className="text-sm md:text-base max-w-xl mx-auto" style={{ color: "var(--color-muted-foreground)" }}>
            A selection of projects I've built — from production apps to open-source tools.
          </p>
        </div>

        {/* Filters */}
        <div className="flex gap-2 mb-8 overflow-x-auto pb-2 justify-center">
          {projectsData?.filters?.map((f) =>
          <button
            key={f}
            onClick={() => setActiveFilter(f)}
            className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap flex-shrink-0 border transition-all duration-200"
            style={{
              fontFamily: "var(--font-heading)",
              background: activeFilter === f ? "var(--color-primary)" : "var(--color-card)",
              color: activeFilter === f ? "#fff" : "var(--color-muted-foreground)",
              borderColor: activeFilter === f ? "var(--color-primary)" : "var(--color-border)",
              boxShadow: activeFilter === f ? "0 0 16px rgba(124,106,247,0.3)" : "none",
            }}>
            
              {f}
            </button>
          )}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered?.map((project) =>
          <ProjectCard key={project?.id} project={project} />
          )}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <Button
            variant="outline"
            size="lg"
            iconName="Github"
            iconPosition="left"
            onClick={() => window.open("https://github.com/rehmatcodemaster", "_blank")}>
            
            View All on GitHub
          </Button>
        </div>
      </div>
    </div>);

}